// https://pinia.vuejs.org/core-concepts/
import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

// It is convention to prefix store names here with "use"
export const useExampleStore = defineStore('example', () => {
  // This is a global state variable
  // It is reactive
  // The value in parenthesis is the starting value
  const count = ref(0);

  // This is referred to as a getter in the context of Pinia stores
  // But it's basically just a computed property
  // Use it like any other state variable
  const tripled = computed(() => count.value * 3);

  // This is an action
  function increment() {
    count.value++;
  }

  return { count, tripled, increment };
});
